module.exports = __webpack_public_path__ + "img/2.240c2cab.svg";